<template>
	<section class="member-coupons">
		<el-card shadow="never">
			<div slot="header" class="clearfix">
				<span>优惠券与权益</span>
				<el-button style="float: right" size="mini">
					兑换优惠码
				</el-button>
			</div>
			<div class="member-card-list">
				<el-card
					v-for="coupon in coupons"
					:key="coupon.id"
					shadow="hover"
				>
					<div class="coupon-amount">
						￥{{ coupon.amount }}
					</div>
					<div class="coupon-name">
						{{ coupon.name }}
					</div>
					<div class="coupon-meta">
						有效期至 {{ coupon.expire }}
					</div>
					<el-tag
						:type="coupon.status === '可用' ? 'success' : 'info'"
						size="mini"
					>
						{{ coupon.status }}
					</el-tag>
				</el-card>
			</div>
			<div v-if="!coupons.length" class="member-placeholder">
				暂无优惠券
			</div>
		</el-card>
	</section>
</template>

<script>
export default {
	name: 'MemberCoupons',
	props: {
		coupons: {
			type: Array,
			default: () => []
		}
	}
}
</script>

<style lang="scss" scoped>
.coupon-amount {
	font-size: 28px;
	font-weight: 600;
	color: #f56c6c;
}

.coupon-name {
	font-size: 16px;
	margin-top: 6px;
}

.coupon-meta {
	font-size: 12px;
	color: #909399;
	margin: 6px 0 12px;
}
</style>

